import React from 'react';
import PropTypes from 'prop-types';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { DataValueMap } from 'Helpers/Testing';

const OutOfOfficeNoticeDialog = ({
  loading,
  handleClose,
  handleSubmit,
  value,
}) => {
  const { outOfOfficeNotificationResource } = useMessagesContext();

  return (
    <NewDialog
      title={outOfOfficeNotificationResource?.attr('title')}
      message={outOfOfficeNotificationResource?.attr('content')}
      cancelLabel={outOfOfficeNotificationResource?.attr('deferredActionTitle')}
      confirmLabel={outOfOfficeNotificationResource?.attr('immediateActionTitle')}
      confirmButtonType="error"
      loading={loading}
      onConfirm={async () => {
        handleSubmit(value, { avoidNotifySupport: 'false' });
        handleClose();
      }}
      onCancel={async (e) => {
        e.stopPropagation();
        handleSubmit(value, { avoidNotifySupport: 'true' });
        handleClose();
      }}
      onClose={async (e) => {
        e.stopPropagation();
        handleSubmit(value, { avoidNotifySupport: 'true' });
        handleClose();
      }}
      maxWidth={'sm'}
      showCloseIcon
      {...DataValueMap.init('out-of-office-notification').build()}
    />
  );
};

OutOfOfficeNoticeDialog.defaultProps = {
};

OutOfOfficeNoticeDialog.propTypes = {
  loading: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};
export { OutOfOfficeNoticeDialog };
